import { useRef, useEffect, useState } from "react";
import ContactMarquee from "./ContactMarquee";
import ContactInfo from "./ContactInfo";
import ContactCanvas from "./ContactCanvas";
import { useContact } from "../../data/content";

function ContactSection({ darkMode, contactTick }) {
  const contact = useContact();
  const mouseRef = useRef({ x: 0, y: 0 });
  const sectionRef = useRef();
  const [flashing, setFlashing] = useState(false);

  useEffect(() => {
    if (!contactTick) return;
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    setFlashing(false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setFlashing(true));
    });
    const t = setTimeout(() => setFlashing(false), 1200);
    return () => clearTimeout(t);
  }, [contactTick]);

  const handleMouseMove = (e) => {
    const rect = sectionRef.current.getBoundingClientRect();
    mouseRef.current = {
      x: ((e.clientX - rect.left) / rect.width) * 2 - 1,
      y: -(((e.clientY - rect.top) / rect.height) * 2 - 1),
    };
  };

  const handleMouseLeave = () => {
    mouseRef.current = { x: 0, y: 0 };
  };

  return (
    <section
      id="contact"
      ref={sectionRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className="relative bg-background-light dark:bg-background-dark pt-24 pb-16"
    >
      <ContactCanvas mouseRef={mouseRef} darkMode={darkMode} />

      <div className="relative z-10 overflow-hidden">
        <ContactMarquee />
      </div>

      <div className={`relative z-10 max-w-5xl mx-auto px-6 text-center mt-16 rounded-2xl py-8 ${flashing ? "contact-flash" : ""}`}>
        <p className="font-sans text-lg text-text-muted-light dark:text-text-muted-dark max-w-sm mx-auto leading-relaxed">
          {contact.blurb}
        </p>
        <ContactInfo />
      </div>
    </section>
  );
}

export default ContactSection;
